export const AUTH_LINK_LIST = 'AUTH_LINK_LIST';
export const AUTH_LINK_WITH_AUTHITEM = 'AUTH_LINK_WITH_AUTHITEM';
export const AUTH_LINK_AUTH_GENERATE = 'AUTH_LINK_AUTH_GENERATE';
export const AUTH_LINK_ADD = 'AUTH_LINK_ADD';
export const AUTH_LINK_DELETE = 'AUTH_LINK_DELETE';
export const AUTH_LINK_UPDATE = 'AUTH_LINK_UPDATE';
export const AUTH_LINK_EMPTY_LIST = 'AUTH_LINK_EMPTY_LIST';
